import { ICarousel } from "../theme/carousel/carousel";

class ProductCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(): void {
    new IntersectionObserver(this.handleAsyncMethods.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }

  handleAsyncMethods(
    entries: IntersectionObserverEntry[],
    observer: IntersectionObserver,
  ): void {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.handleDynamicRecommendations();
  }

  /**
   * Handles dynamically fetching and setting product recommendations if set
   * @returns Promise<void>
   */
  async handleDynamicRecommendations(): Promise<void> {
    if (!this.dataset.url) {
      return;
    }

    try {
      const response = await fetch(this.dataset.url as string);
      const text = await response.text();
      const html = document.createElement("div");
      html.innerHTML = text;
      const recommendations = html.querySelector("uwp-product-carousel");

      if (!recommendations || !recommendations.innerHTML.trim().length) {
        return;
      }

      this.innerHTML = recommendations.innerHTML;
      this.reinitialiseCarousel();
    } catch (error: unknown) {
      throw new Error(error as string);
    }
  }

  reinitialiseCarousel(): void {
    const carousel = this.querySelector("uwp-carousel") as null | ICarousel;

    if (!carousel) {
      return;
    }

    carousel.createCarousel();
  }
}

customElements.define("uwp-product-carousel", ProductCarousel);
